import React from 'react';

const withStopPropagation = (cb: () => void) => (ev: React.MouseEvent) => {
    ev.stopPropagation();
    cb();
};

export default withStopPropagation;
